<template>
  <common-dialog
    width="60%"
    title="搜索上传过的附件"
    :visible.sync="dialogVisible"
    modal-append-to-body
    append-to-body
    :before-close="handleCancelClick"
  >
    <div class="attachment">
      <div class="content" v-loading="loading">
        <el-input
          v-model="uploadedName"
          style="width:320px"
          clearable
          @keyup.enter.native="queryUploadedName"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="queryUploadedName"
          >
          </el-button>
        </el-input>
        <div class="title">搜索文件</div>
        <div class="fileList" style="margin-right:20px;border-left:1px #333">
          <div
            :class="[
              'list',
              { 'list-active': choseFiles.find(i => i.id === item.id) }
            ]"
            v-for="item in tableData.list"
            :key="item.id"
            @click="chooseFileList(item)"
          >
            <span style="width:70%">
              {{ item.attachmentOriginalName }}
              <span v-show="choseFiles.find(i => i.id === item.id)"> 🗸 </span>
            </span>
            <span>{{ moment(item.createTm).format("YYYY-MM-DD") }}</span>
          </div>
        </div>
        <el-pagination
          layout="sizes, prev, pager, next"
          :total="tableData.total"
          :page-size="tableData.pageSize"
          :page-sizes="tableData.pageSizeArray"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          :current-page="tableData.pageNum"
        >
        </el-pagination>
      </div>
      <div class="content">
        <el-upload
          action
          multiple
          style="display:inline"
          :show-file-list="false"
          fullscreen="true"
          :accept="attaFileSuf"
          :http-request="attachmentUpload"
          :before-upload="handleBeforeUpload"
        >
          <common-button type="cancel">添加本地附件 </common-button>
        </el-upload>
        <div class="title">本地文件</div>
        <div class="fileList">
          <div
            :class="['list', { 'list-active': choseFiles.includes(item) }]"
            v-for="(item, index) in localFiles"
            :key="item.id"
            @click="chooseFileList(item, index)"
          >
            <span style="width:70%">
              {{ item.attachmentOriginalName }}
              <span v-show="choseFiles.includes(item)"> 🗸 </span>
            </span>
            <span>{{ moment(item.createTm).format("YYYY-MM-DD") }}</span>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <common-button
        style="margin-right:50px"
        @click="handleCancelClick"
        type="cancel"
        >取消</common-button
      >
      <common-button type="primary" @click="handleAddAttachment"
        >确定</common-button
      >
    </span>
  </common-dialog>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";
import {
  ATTA_UPLOAD_COMPONENT_TYPE_STR,
  ATTA_UPLOAD_CASE_SHARE_TYPE_STR
} from "@/constants/constants";
export default {
  name: "HistoricalAttachment",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    hasCaseShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      choseFiles: [],
      localFiles: [],
      attachmentsMultipart: [],
      uploadedName: "",
      loading: false,
      attaFileSuf: this.hasCaseShare
        ? ATTA_UPLOAD_CASE_SHARE_TYPE_STR
        : ATTA_UPLOAD_COMPONENT_TYPE_STR,

      tableData: {
        //当前登录人
        userId: "",
        isLoading: false,
        pageNum: 1,
        pageSize: 10,
        currentPage: 1,
        pageSizeArray: PAGE_SIZE_ARRAY,
        list: [],
        total: 0
      },
      globalIndex: null
    };
  },
  computed: {},
  mounted() {},
  methods: {
    queryUploadedName() {
      this.loading = true;
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/userInfo/attachment/findAttachmentByNameAndUserId",
          {
            token: cookie.getCookie("token"),
            data: {
              pageNum: this.tableData.pageNum,
              pageSize: this.tableData.pageSize,
              attachmentName: this.uploadedName,
              authKey: cookie.getCookie("zldAuthKey")
            }
          }
        )
        .then(response => {
          if ((response.data.code = "00000")) {
            this.tableData.list = [];
            this.tableData.list = response.data.data.attachments;
            this.tableData.total = response.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    chooseFileList(item, index) {
      if (this.choseFiles.includes(item)) {
        let ind;
        if (item.id) {
          ind = this.choseFiles.findIndex(i => item.id === i.id);
        } else {
          ind = this.choseFiles.findIndex(i => item.uid === i.uid);
          this.attachmentsMultipart.splice(index, 1);
        }
        this.choseFiles.splice(ind, 1);
      } else {
        item.url =
          window.config.api.baseUrl +
          "/eims-api/attachment/findFile?token=" +
          cookie.getCookie("token") +
          "&code=" +
          item.code;
        this.choseFiles.push(item);
      }
    },
    attachmentUpload(file) {
      this.attachmentsMultipart.push(file);
    },
    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (this.hasCaseShare) {
        this.attaFileSuf = ATTA_UPLOAD_CASE_SHARE_TYPE_STR;
      } else {
        this.attaFileSuf = ATTA_UPLOAD_COMPONENT_TYPE_STR;
      }
      if (!this.attaFileSuf.includes(testMsg)) {
        this.$message({
          message: "上传附件类型不合法！",
          type: "warning",
          showClose: true
        });
        return false;
      } else {
        const url = URL.createObjectURL(new Blob([file], { type: file.type }));
        //将附件的信息添加到讨论中
        file.attachmentOriginalName = file.name;
        file.url = url;
        file.localUrl = url;
        this.choseFiles.push(file);
        this.localFiles.push(file);
      }
    },
    handleCancelClick() {
      this.$emit("update:dialogVisible", false);
      this.choseFiles = [];
      this.localFiles = [];
      this.attachmentsMultipart = [];
      this.tableData.list = [];
      this.tableData.total = 0;
      this.uploadedName = "";
    },
    handleAddAttachment() {
      this.$emit("AddAttachment", this.choseFiles, this.attachmentsMultipart);
      this.handleCancelClick();
    },

    //分页
    handlePageChange(val) {
      this.tableData.pageNum = val;
      this.queryUploadedName();
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.queryUploadedName();
    }
  }
};
</script>
<style lang="scss" scoped>
.attachment {
  display: flex;
  justify-content: space-around;
  .content {
    width: 50%;
    .title {
      margin-top: 10px;
      font-weight: 600;
    }
    .fileList {
      height: calc(100vh - 605px);
      overflow: auto;

      .list {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        &:hover {
          color: #4eccee;
        }
        &-active {
          color: #4eccee;
        }
      }
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
// /deep/ .el-dialog {
//   height: 100%;
// }
</style>



// WEBPACK FOOTER //
// src/components/common/HistoricalAttachment.vue